/**
 * Zod schemas for admin management endpoints (API-1267).
 *
 * These gate destructive admin routes in `services/backend-api/src/routes/versions/v1/admin.ts`
 * and are kept here so the same validators can be reused by other services or clients.
 */
import { z } from 'zod';

/** Matches the Prisma `Role` enum — kept in sync with `packages/db-core/prisma/schema.prisma`. */
export const adminRoleSchema = z.enum(['USER', 'MODERATOR', 'ADMIN', 'SUPER_ADMIN']);
export type AdminRole = z.infer<typeof adminRoleSchema>;

/** Body for `PATCH /api/v1/admin/users/:userId/role`. */
export const changeRoleBodySchema = z
  .object({
    role: adminRoleSchema,
  })
  .strict();
export type ChangeRoleBody = z.infer<typeof changeRoleBodySchema>;

/** Shared non-empty CUID-ish identifier guard for path params. */
export const adminIdParamSchema = z.string().trim().min(1).max(128);
